export var WISTIA_SCRIPT_URL = 'https://fast.wistia.com/assets/external/E-v1.js';
export var PLAYER_TYPES = {
  // The video params are defined inside Wistia Admin
  DEFAULT_FROM_WISTIA: 'default-from-wistia',
  // Muted, no controls, auto-play
  VIDEO_RESPONSIVE: 'video-responsive',
  // Muted, no controls, video as background in loop
  VIDEO_BACKGROUND: 'video-background'
};
export var DEFAULT_VIDEO_ID = 'oayizyy8pl';